import React, { useEffect, useState } from 'react';
import Axios from '../../utils/Axios';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import SummaryAPI from "../../common/SummaryAPI";

const Lists = () => {
  const user = useSelector(state => state.user);
  const [watchlist, setWatchlist] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || !user._id) {
      return;
    }

    const fetchWatchlist = async () => {
      try {
        const response = await Axios(SummaryAPI.fetchWatchlist(user._id));
        if (response.data.error) {
        toast.error(response.data.message);
        return;
      }
      if (response.data.success) {
        toast.success(response.data.message);
      }
        setWatchlist(response.data.data || []);
      } catch (err) {
        console.error(err);
        toast.error('Failed to load watchlist');
      } finally {
        setLoading(false);
      }
    };

    fetchWatchlist();
  }, [user]);

  if (!user?._id) return <p>Please login to see your watchlist.</p>;
  if (loading) return <p>Loading...</p>;
  if (!watchlist || !watchlist.length) return <p>Your watchlist is empty.</p>;

  return (
    <div>
      <h2>Your Watchlist</h2>
      <ul>
        {watchlist.map(movie => (
          <li key={movie.movieId} style={{ marginBottom: '1rem' }}>
            <img
              src={`https://image.tmdb.org/t/p/w92${movie.posterPath}`}
              alt={movie.title}
              style={{ marginRight: 10 }}
            />
            {movie.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Lists;
